import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor() { }

  resetErrors(form: any) {
    Object.keys(form.controls).forEach((key) => {
      form.get(key)?.setErrors(null);
    });
  }

  setValidationErrors(form: any, validationErrors: any) {
    validationErrors?.filter((v:any) => v.field != null).forEach((v:any) => {
      form.get(v.field)?.setErrors({"backendError": v.defaultMessage});
    })
  }

}
